import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=0c7a90d6&"
import script from "./Signup.vue?vue&type=script&lang=js&"
export * from "./Signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7a90d6')) {
      api.createRecord('0c7a90d6', component.options)
    } else {
      api.reload('0c7a90d6', component.options)
    }
    module.hot.accept("./Signup.vue?vue&type=template&id=0c7a90d6&", function () {
      api.rerender('0c7a90d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/global/DialogAuth/Signup.vue"
export default component.exports